
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire16e4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire16e4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7nhm9", function(module, exports) {

$parcel$export(module.exports, "selectLabel", () => $55e824ff15c161b3$export$b1245c4d27ba3799);
$parcel$export(module.exports, "deselectLabel", () => $55e824ff15c161b3$export$7e352004e75cb08e);
$parcel$export(module.exports, "selectFirstPlanetFactsLabel", () => $55e824ff15c161b3$export$f0682e84310f35a4);
$parcel$export(module.exports, "removeElement", () => $55e824ff15c161b3$export$f883456a56996078);
$parcel$export(module.exports, "insertPlanetSurfaceImage", () => $55e824ff15c161b3$export$b6b79edb4b4e8910);
$parcel$export(module.exports, "selectLabelAndLabelContainer", () => $55e824ff15c161b3$export$5d2a0799dfb009a4);
$parcel$export(module.exports, "hideSidebar", () => $55e824ff15c161b3$export$1fcd7bb3ffed1968);
$parcel$export(module.exports, "displaySidebar", () => $55e824ff15c161b3$export$78409a03e6d6ae27);
$parcel$export(module.exports, "displayFactsAndInfo", () => $55e824ff15c161b3$export$eb0ee1cfff0b38a8);
$parcel$export(module.exports, "hideFactsAndInfo", () => $55e824ff15c161b3$export$16e9fd622f7806fd);
$parcel$export(module.exports, "selectContainer", () => $55e824ff15c161b3$export$3db7218f5d99c5f1);
$parcel$export(module.exports, "changeContentContainerBackground", () => $55e824ff15c161b3$export$554eb6571155db68);
$parcel$export(module.exports, "addOrRemoveContainerHoverClass", () => $55e824ff15c161b3$export$7ea4e39278c50d7a);
$parcel$export(module.exports, "handleHeaderPlanetsHover", () => $55e824ff15c161b3$export$b889a1497de6f451);
$parcel$export(module.exports, "changeHeaderPlanetColor", () => $55e824ff15c161b3$export$fbcd83d3b4f20d20);
// HELPERS
function $55e824ff15c161b3$var$changeLabelContainerBorderColor(labelContainer, color) {
    labelContainer.classList.remove("container--selected");
    labelContainer.style.borderBottom = `0.4rem solid ${color}`;
}
function $55e824ff15c161b3$var$makeLabelWhite(label) {
    label.classList.remove("label--not-selected");
    label.classList.add("label--selected");
}
function $55e824ff15c161b3$var$makeLabelWhite50Percent(label) {
    label.classList.remove("label--selected");
    label.classList.add("label--not-selected");
}
function $55e824ff15c161b3$export$b1245c4d27ba3799(target, currentPlanetData) {
    $55e824ff15c161b3$var$makeLabelWhite(target);
    // Change the label container's border-bottom color to the current planet's color
    $55e824ff15c161b3$var$changeLabelContainerBorderColor(target.closest(".planet-facts__label-container"), currentPlanetData.color);
}
function $55e824ff15c161b3$export$7e352004e75cb08e(label) {
    $55e824ff15c161b3$var$makeLabelWhite50Percent(label);
    // Make the border-bottom of the label container that was not selected transparent
    $55e824ff15c161b3$var$changeLabelContainerBorderColor(label.closest(".planet-facts__label-container"), "transparent");
}
function $55e824ff15c161b3$export$f0682e84310f35a4(planetFactsLabel, currentPlanetData) {
    for (let label of planetFactsLabel)// Deselect the currently selected label
    if (label.classList.contains("label--selected")) $55e824ff15c161b3$export$7e352004e75cb08e(label);
    // Make the first 'planetFactsLabel' white and change the first label container's border-bottom color to that planet's color
    $55e824ff15c161b3$export$b1245c4d27ba3799(planetFactsLabel[0], currentPlanetData);
}
function $55e824ff15c161b3$export$f883456a56996078(element) {
    if (element) element.remove();
}
function $55e824ff15c161b3$export$b6b79edb4b4e8910(currentPlanetData, planetImage, planetSurfaceImageObj) {
    const planetSurfaceImageHTML = `<img class='planet-info__surface-img' src=${currentPlanetData.images.geology} alt='Planet image'/>`;
    // Insert 'planetSurfaceImage' right after 'planetImage'
    planetImage.insertAdjacentHTML("afterend", planetSurfaceImageHTML);
    planetSurfaceImageObj.image = document.querySelector(".planet-info__surface-img");
}
function $55e824ff15c161b3$export$5d2a0799dfb009a4(contentContainer, target, currentPlanetData, planetFactsLabel) {
    for(let i = 0; i < contentContainer.length; i++)if (target === contentContainer[i]) $55e824ff15c161b3$export$b1245c4d27ba3799(planetFactsLabel[i], currentPlanetData);
    else $55e824ff15c161b3$export$7e352004e75cb08e(planetFactsLabel[i]);
}
function $55e824ff15c161b3$export$1fcd7bb3ffed1968(headerMenuIcon, sidebar) {
    headerMenuIcon.classList.remove("header__menu-icon--clicked");
    sidebar.classList.remove("sidebar--open");
}
function $55e824ff15c161b3$export$78409a03e6d6ae27(headerMenuIcon, hideFactsAndInfo, sidebar, planetFacts, planetInfo) {
    headerMenuIcon.classList.add("header__menu-icon--clicked");
    hideFactsAndInfo(planetFacts, planetInfo);
    sidebar.classList.add("sidebar--open");
}
function $55e824ff15c161b3$export$eb0ee1cfff0b38a8(planetFacts, planetInfo) {
    planetFacts.classList.remove("hidden");
    planetInfo.classList.remove("hidden");
}
function $55e824ff15c161b3$export$16e9fd622f7806fd(planetFacts, planetInfo) {
    planetFacts.classList.add("hidden");
    planetInfo.classList.add("hidden");
}
function $55e824ff15c161b3$export$3db7218f5d99c5f1(target, contentContainer, currentPlanetData) {
    for (let container of contentContainer)if (container === target) {
        // If the target container already has the "content-container--selected" class, then do nothing
        if (target.classList.contains("content-container--selected")) return;
        // Change the background color of the target container
        target.classList.remove("content-container--hovered");
        target.style.background = currentPlanetData.color;
    } else {
        // Remove the "content-container--selected" class from the container if it has it and reset the container's background color to its initial state
        container.classList.remove("content-container--selected");
        container.style.background = "initial";
    }
}
function $55e824ff15c161b3$export$554eb6571155db68(contentContainer, currentLabelIndex, currentPlanetData) {
    contentContainer[0].classList.remove("content-container--selected");
    // Change each content container's background back to its initial state
    contentContainer.forEach((container)=>{
        container.style.background = "initial";
    });
    // Change the background of the content container that corresponds with the label that was selected
    contentContainer[currentLabelIndex].style.background = currentPlanetData.color;
}
function $55e824ff15c161b3$export$7ea4e39278c50d7a(e, eventName) {
    const target = e.target.closest(".planet-info__content-container");
    if (!target) return;
    if (eventName === "mouseover") // Change background color of content container to iron
    target.classList.add("content-container--hovered");
    if (eventName === "mouseout") target.classList.remove("content-container--hovered");
}
function $55e824ff15c161b3$var$isViewportWidthBelowThreshold() {
    const viewportWidth = window.innerWidth;
    return viewportWidth < 1104 ? true : false;
}
function $55e824ff15c161b3$var$isTouchDevice() {
    return "ontouchstart" in window ? true : false;
}
function $55e824ff15c161b3$export$b889a1497de6f451(e, planets, eventType) {
    if (!e.target.classList.contains("header__planet")) return;
    const headerPlanetContainer = e.target.closest(".header__planet-container");
    // If the viewport width is less than 1104px, then do nothing
    if ($55e824ff15c161b3$var$isViewportWidthBelowThreshold()) return;
    // If the device is a touch device, then do nothing
    if ($55e824ff15c161b3$var$isTouchDevice()) return;
    if (eventType === "mouseover") {
        // Find the data for the 'header__planet' that was hovered
        const headerPlanetName = e.target.textContent.toLowerCase();
        const headerPlanetData = planets.find((planet)=>planet.name.toLowerCase() === headerPlanetName);
        // Change the border-top color of the target element's parent container to that planet's color
        headerPlanetContainer.style.borderTop = `0.4rem solid ${headerPlanetData.color}`;
    }
    if (eventType === "mouseout") // For the target element that was just hovered, change the border-top of its parent container back to transparent
    headerPlanetContainer.style.borderTop = "0.4rem solid transparent";
}
function $55e824ff15c161b3$export$fbcd83d3b4f20d20(headerPlanet, elementClicked, currentPlanet, currentPlanetData, target) {
    for (let element of headerPlanet){
        // Reset the color of all 'header__planet' elements back to white
        element.classList.remove("header__planet--selected");
        element.style.color = "#fff";
        // Change the color of the 'header__planet' element that corresponds with the 'sidebar__planet-container' that was clicked
        if (elementClicked === "sidebar__planet-container") {
            if (element.textContent.toLowerCase() === currentPlanet) element.style.color = currentPlanetData.color;
        }
    }
    // Change the color of the 'header__planet' element that was clicked to that planet's color
    if (elementClicked === "header__planet") target.style.color = currentPlanetData.color;
}

});


parcelRequire("7nhm9");

//# sourceMappingURL=index.bae6eda1.js.map
